import RestClient from '../RestClient/RestClient';
import { apiHosts } from '../RestClient/FetchHelper.config';
import { getCookie } from '../helpers/Cookies';
import { cstToUTC, getChannel } from '../Common/CommonHelper';
import IrisStickyTimerConstant from './IrisStickyTimerConstants';

const getIrisStickyTimer = (params) => {
    try {
        const context = RestClient.getContext();
        const channel = getChannel(context);
        const config = {
            url: `${IrisStickyTimerConstant.IrisStickyTimerUrl}${params}`,
            apiHost: apiHosts.content,
            excludeVersion: true,
            credentials: 'include',
            isXCloudHeaderRequired: true,
            channel,
        };
        if (context.isPreview) {
            const dateValue = cstToUTC(getCookie('DP_PREVIEW_DATE'), context);
            // Check for the Preview Environment Date
            /* istanbul ignore next */
            config.previewDate = (dateValue || new Date()).toISOString();
        }
        return RestClient.get(config).then((json) => json);
    } catch (e) {
        /* istanbul ignore next */
        return e;
    }
};

export default getIrisStickyTimer;
